/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDashyKpiRecapTemplateConfig } from '../../models/api-response-dashy-kpi-recap-template-config';
import { DashyKpiRecapTemplateConfig } from '../../models/dashy-kpi-recap-template-config';

export interface UpdateDashyKpiRecapTemplateConfig$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: DashyKpiRecapTemplateConfig
}

export function updateDashyKpiRecapTemplateConfig(http: HttpClient, rootUrl: string, params: UpdateDashyKpiRecapTemplateConfig$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDashyKpiRecapTemplateConfig>> {
  const rb = new RequestBuilder(rootUrl, updateDashyKpiRecapTemplateConfig.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDashyKpiRecapTemplateConfig>;
    })
  );
}

updateDashyKpiRecapTemplateConfig.PATH = '/v1/api/admin-ui/dashy-kpi-recap-template';
